import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Drop-Down",
  "use": "icon-Drop-Down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-Drop-Down\"><path d=\"M3.853 7.354a.5.5 0 0 1 .354-.854h7.485a.5.5 0 0 1 .354.854l-3.743 3.742a.5.5 0 0 1-.707 0L3.853 7.354Z\" fill=\"#4066D4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol